import { makeStyles } from 'tss-react/mui';

const name = 'BundleProgressLabel';

export const useBundleProgressLabelStyles = makeStyles<boolean>({ name })(
  (theme, isShortened) => ({
    root: {
      display: 'flex',
      alignItems: 'center',

      gap: isShortened ? theme.spacing(0.5) : theme.spacing(1),

      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  }),
);
